/* less/lib/less/index */ function _(require, module, exports) {
    module.exports = function (environment, fileManagers) {
        var SourceMapOutput, SourceMapBuilder, ParseTree, ImportManager, Environment;
        var initial = {
            version: [3, 9, 0],
            data: require(171) /* ./data */,
            tree: require(223) /* ./tree */,
            Environment: (Environment = require(176) /* ./environment/environment */),
            AbstractFileManager: require(174) /* ./environment/abstract-file-manager */,
            AbstractPluginLoader: require(175) /* ./environment/abstract-plugin-loader */,
            environment: (environment = new Environment(environment, fileManagers)),
            visitors: require(249) /* ./visitors */,
            Parser: require(200) /* ./parser/parser */,
            functions: require(184) /* ./functions */(environment),
            contexts: require(169) /* ./contexts */,
            SourceMapOutput: (SourceMapOutput = require(204) /* ./source-map-output */(environment)),
            SourceMapBuilder: (SourceMapBuilder = require(203) /* ./source-map-builder */(SourceMapOutput, environment)),
            ParseTree: (ParseTree = require(196) /* ./parse-tree */(SourceMapBuilder)),
            ImportManager: (ImportManager = require(192) /* ./import-manager */(environment)),
            render: require(202) /* ./render */(environment, ParseTree, ImportManager),
            parse: require(197) /* ./parse */(environment, ParseTree, ImportManager),
            LessError: require(194) /* ./less-error */,
            transformTree: require(205) /* ./transform-tree */,
            utils: require(245) /* ./utils */,
            PluginManager: require(201) /* ./plugin-manager */,
            logger: require(195) /* ./logger */
        };
        // Create a public API
        var ctor = function (t) {
            return function () {
                var obj = Object.create(t.prototype);
                t.apply(obj, Array.prototype.slice.call(arguments, 0));
                return obj;
            };
        };
        var t, api = Object.create(initial);
        for (var n in initial.tree) {
            /* eslint guard-for-in: 0 */
            t = initial.tree[n];
            if (typeof t === 'function') {
                api[n.toLowerCase()] = ctor(t);
            }
            else {
                api[n] = Object.create(null);
                for (var o in t) {
                    /* eslint guard-for-in: 0 */
                    api[n][o.toLowerCase()] = ctor(t[o]);
                }
            }
        }
        return api;
    };
}
